import { injectIntl } from "react-intl";
import { IgnoreFiltersAcknowledgementDialog } from './IgnoreFiltersAcknowledgementDialog';

export const IgnoreFiltersDialog = injectIntl(IgnoreFiltersAcknowledgementDialog);